export const secure2u = {
  dontClose: 'Jangan menutup halaman ini!',
  dontLogin: 'Anda tidak perlu login melalui M2U ID App untuk melanjutkan transaksi.',
  makeSureActive:
    'Pastikan Secure2u di M2U ID App dan pengaturan notifikasi di perangkat Anda aktif.<br/> Silakan klik notifikasi untuk melakukan konfirmasi transaksi Anda.',
  completeGuide: 'Untuk Panduan Autentikasi Transaksi,',
  timeStamp: 'Masa berlaku autentikasi akan berakhir',
  timestamp2: 'dalam {timestamp}',
  clickHere: 'klik di sini',
  stepOne: 'LANGKAH 1',
  stepTwo: 'LANGKAH 2',
  stepThree: 'LANGKAH 3',
  descriptionOne:
    'Buka konfirmasi transaksi dengan klik notifikasi yang muncul. Jika Anda tidak menerima notifikasi, harap klik menu <b>“Autentikasi”</b> pada halaman login M2U ID App',
  descriptionTwo: 'Autentikasi transaksi. Apabila sudah sesuai, klik “Konfirmasi”',
  descriptionThree: 'Masukkan <em>passcode</em> Secure2u untuk autentikasi transaksi',
  cancelTransaction: 'Masa berlaku autentikasi akan berakhir',
  within: 'dalam',
  questionRetry: 'Masa berlaku konfirmasi transaksi Anda sudah berakhir. Apakah Anda tidak ',
  questionRetry2: 'mendapatkan notifikasi? Silakan klik tombol ',
  questionRetry3: '<b>"Kirim Ulang"</b>',
  buttonRetry: 'KIRIM ULANG',
  guideConfirmation: 'Panduan Konfirmasi Transaksi',
  titleNotActive: 'Anda belum melakukan aktivasi Secure2u',
  descNotActive:
    'Pastikan Anda sudah memiliki M2U ID App pada Handphone Anda.  Klik tombol “Lihat Panduan” untuk melihat instruksi penggantian password',
  buttonHowTo: 'Lihat Panduan',
  ok: 'Ok',
  expired: 'Sesi autentikasi Anda sudah berakhir. Mohon lakukan konfirmasi ulang dan klik notifikasi terbaru pada M2U ID App',
};
